(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/components/betslip.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/components/betslip.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const Betslip = _ref => {
  let {
    hasKungKeno,
    selectedPrice,
    isVisible,
    handleDemoGame,
    handlePayGame,
    isAlreadyPayed
  } = _ref;
  const [playerBalance, setPlayerBalance] = useState(0);
  useEffect(() => {
    svs.components.account_balance.get(true, balance => {
      setPlayerBalance(balance);
    });
  }, []);
  return React.createElement(Payfooter, {
    balance: playerBalance,
    buttons: [isAlreadyPayed ? {
      onClick: handlePayGame,
      primary: true,
      disabled: !isVisible,
      text: 'Fortsätt'
    } : {
      onClick: handlePayGame,
      pay: true,
      disabled: !isVisible
    }, {
      onClick: handleDemoGame,
      secondary: true,
      text: 'Provspela',
      disabled: !isVisible
    }, {
      className: 'js-pause24-trigger',
      link: true,
      text: 'SPELPAUS24'
    }],
    isBottom: true,
    sum: isVisible ? selectedPrice * (hasKungKeno + 1) : 0
  });
};
setGlobal('svs.kenoXpress.react.components.Betslip', Betslip);

 })(window);